import { useQuery } from '@tanstack/react-query'
import { useOrganization } from '@/contexts/OrganizationContext'
import { createTenantDb, type PacksPageQuery } from '@/lib/db-tenant'
import { BANKING_KEYS, keepPreviousForOrg } from '@/lib/query-keys'

/**
 * One server-side page of the Settings → Packs table, each pack with its
 * member facilities' names, plus the pack total. Other screens keep using
 * `usePacks` (the whole list).
 *
 * The previous page stays on screen while the next one loads (same org only).
 */
export function usePacksPage(query: PacksPageQuery) {
  const orgId = useOrganization().currentOrganization?.id
  return useQuery({
    queryKey: BANKING_KEYS.packsPage(orgId, query),
    queryFn: async () => {
      if (!orgId) throw new Error('No organization selected')
      const { data, error } = await createTenantDb(orgId).packs.listPage(query)
      if (error) throw new Error(error.message)
      return data
    },
    enabled: !!orgId,
    placeholderData: keepPreviousForOrg(orgId, 2),
  })
}
